const MOBILE_UA =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i;

export type ClientSurface = "h5" | "web";

/** 自动识别 H5（手机）与 Web（桌面） */
export function detectClientSurface(): ClientSurface {
  if (typeof window === "undefined") {
    return "web";
  }
  const narrow = window.matchMedia("(max-width: 767px)").matches;
  const mobileUa = MOBILE_UA.test(navigator.userAgent);
  return narrow || mobileUa ? "h5" : "web";
}

export function formatAmountYuan(v: number): string {
  if (!Number.isFinite(v)) {
    return "0.00";
  }
  return v.toFixed(2);
}
